import { FetchFilterOption } from '../../types/api/FiltersTypes';

import { FILTERS_CACHE_ACTIONS } from '../../constants/actions';
const {
  SET_PFL_FILTERS,
} = FILTERS_CACHE_ACTIONS;

export const setPflFilters = (payload: Array<FetchFilterOption>) => ({
  type: SET_PFL_FILTERS,
  payload,
});
